// extracted by mini-css-extract-plugin
export default {"spin":"styles_spin__ALwb4"};